import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from '@shared/validators';
import { BaseComponent } from '@app/common/modules/base/base.component';
import { LoginController } from '@modules/auth/controllers/login.controller';

interface LoginType {
  name: 'cpf' | 'cnpj' | 'email';
  type: string;
  label: string;
  icon: string;
  mask: string;
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent extends BaseComponent {
  public loginForm!: FormGroup;
  public currentLoginType!: LoginType;
  public passwordVisible = false;
  public isSubmitting = false;

  public loginTypes: LoginType[] = [
    {
      name: 'cpf',
      type: 'text',
      label: 'CPF',
      icon: 'person',
      mask: '000.000.000-00',
    },
    {
      name: 'cnpj',
      type: 'text',
      label: 'CNPJ',
      icon: 'business',
      mask: 'AA.AAA.AAA/AAAA-99',
    },
    {
      name: 'email',
      type: 'email',
      label: 'E-mail',
      icon: 'email',
      mask: '',
    },
  ];

  constructor(
    public loginController: LoginController,
    private formBuilder: FormBuilder,
    private router: Router
  ) {
    super('Login - Portal do Cliente');
    this.createForm();
  }

  private createForm(): void {
    this.loginForm = this.formBuilder.group({
      login: ['', [Validators.required]],
      senha: ['', [Validators.required, Validators.minLength(4)]],
      manterConectado: [false],
    });
  }

  public changeLoginType(loginType: LoginType): void {
    const login = this.loginForm.get('login');

    if (!login) return;

    const validators = {
      cpf: [Validators.required, CustomValidators.cpf],
      cnpj: [Validators.required, CustomValidators.cnpj],
      email: [Validators.required, Validators.email],
    };

    login.reset();
    login.setValidators(validators[loginType.name]);
    login.updateValueAndValidity();

    this.currentLoginType = loginType;
  }

  public submit(): void {
    if (this.loginForm.valid) {
      this.isSubmitting = true;

      const data = {
        [this.currentLoginType.name]: this.loginForm.value.login,
        senha: this.loginForm.value.senha,
        manterConectado: this.loginForm.value.manterConectado,
      };

      this.loginController.login(data).subscribe({
        next: () => {
          this.isSubmitting = false;
          this.router.navigate(['/']);
        },
        error: (error) => {
          this.loginForm.setErrors({
            incorrect: true,
            message: error.message,
          });

          this.isSubmitting = false;
        }
      });
    }
  }
}
